module.exports = __webpack_public_path__ + "static/media/upgrade_icon.1eb4e344.svg";